import SceneCardGrid from '@/components/app/scenes/SceneCardGrid';
import SceneControls from '@/components/app/scenes/SceneControls';
import Loader from '@/components/Loader';
import { useScenes } from '@/hooks/app/useScenes';

const SceneCardContainer = () => {
	const { scenes, selectedScene } = useScenes();

	return (
		<>
			<SceneControls />
			{scenes?.length > 0 ? <SceneCardGrid scenes={scenes} selectedScene={selectedScene} /> : <Loader />}
		</>
	);
};

export default SceneCardContainer;
